export interface ElementBaseProps {
  /**
   * Input label.
   */
  label: string
  /**
   * Message under input?
   */
  message?: React.ReactNode
  /**
   * Class?
   */
  className?: string
}

export const ElementWrapper = ({
  label,
  children,
  message,
  className,
}: React.PropsWithChildren<ElementBaseProps>) => {
  return (
    <div className={className}>
      <label className="type-body-sm-bold">
        {label}
        {children}
      </label>
      {Boolean(message) && <span className="type-body-xs">{message}</span>}
    </div>
  )
}
